module.exports = __webpack_public_path__ + "9abaa851423567407550998b97f2d278.pdf";